export default __webpack_public_path__ + "static/media/950.51aa48d4.png";